;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"899b563f564cd45c91b6c0a3ed8e118ed9ee6e48"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import {
	feedbackIntegration,
	init,
	replayIntegration
} from "@sentry/nextjs";

import {
	apiUrl,
	siteOrigin
} from "~/const";
import { sentryConfig } from "~/sentry";

init({
	...sentryConfig,
	integrations: [
		replayIntegration({
			blockAllMedia: false,
			maskAllText: false,
			maskAllInputs: true,
			mask: ["[data-mask]"],
			block: ["[data-block]"],
			networkDetailAllowUrls: [
				window.location.origin,
				new URL(siteOrigin).origin,
				new URL(apiUrl).origin
			]
		}),
		feedbackIntegration({
			autoInject: false
		})
	]
});
